// extracted by mini-css-extract-plugin
module.exports = {"plan":"styles_plan__3TYF0","plans":"styles_plans__2YMqK","currency":"styles_currency__3WJnk"};